<template>
  <StandardDialogFullScreen opacity="1" v-if="sequence">
    <template #dialog>
      <router-view v-if="$route.matched[3] && $route.matched[3].name !== 'RecommendedWaggon'" style="z-index: 20" />
    </template>
    <template #header-workpackages>
      <StandardDialog v-if="show_dialog" @click-outside="show_dialog = false">
        <template #content>
          <v-card color="secondary" height="100%" class="d-flex flex-column">
            <v-card-title>
              {{ $t('WorkBench.Editor.Download.Header') }}
            </v-card-title>
            <v-card-text>
              {{ $t('WorkBench.Editor.Download.Text') }}
            </v-card-text>
            <v-spacer></v-spacer>
            <v-card-actions>
              <v-btn v-if="template_type === 'community'" @click="createWBObject({
                url: [
                  { sequences: '0/copyfromcommunity' },
                  { showWithEntitiesNormalized: '' },
                ],
                wb_object: {
                  csequence: sequence.id,
                  copy_workpackages: true
                }
              }).then(() => {
                sequence.likes.some(like => like.user.id === getUserId) ?
                  show_dialog = false :
                  updateWBObject({
                    url: [
                      { csequences: sequence.id },
                      { like: '' },
                    ],
                    update: {
                      likes: getLikes(sequence.likes)
                    }
                  }).then(() => { show_dialog = false; })
              })" color="green" text>{{ $t('WorkBench.Editor.Download.WithWorkPackages') }}</v-btn>

              <v-btn v-if="template_type === 'community'" @click="createWBObject({
                url: [
                  { sequences: '0/copyfromcommunity' },
                  { showWithEntitiesNormalized: '' },
                ],
                wb_object: {
                  csequence: sequence.id,
                  copy_workpackages: false
                }
              }).then(() => {
                sequence.likes.some(like => like.user.id === getUserId) ?
                  show_dialog = false :
                  updateWBObject({
                    url: [
                      { csequences: sequence.id },
                      { like: '' },
                    ],
                    update: {
                      likes: getLikes(sequence.likes)
                    }
                  }).then(() => { show_dialog = false; })
              })" color="green" text>{{ $t('WorkBench.Editor.Download.WithoutWorkPackages') }}</v-btn>

              <!-- BUSINESS -->
              <v-btn v-if="template_type === 'company'" @click="createWBObject({
                url: [
                  { sequences: '0/copyfrombusiness' },
                  { showWithEntitiesNormalized: '' },
                ],
                wb_object: {
                  bsequence: sequence.id,
                  copy_workpackages: true
                }
              }).then(() => {
                sequence.likes.some(like => like.user.id === getUserId) ?
                  show_dialog = false :
                  updateWBObject({
                    url: [
                      { bsequences: sequence.id },
                      { like: '' },
                    ],
                    update: {
                      likes: getLikes(sequence.likes)
                    }
                  }).then(() => { show_dialog = false; })
              })" color="green" text>{{ $t('WorkBench.Editor.Download.WithWorkPackages') }}</v-btn>

              <v-btn v-if="template_type === 'company'" @click="createWBObject({
                url: [
                  { sequences: '0/copyfrombusiness' },
                  { showWithEntitiesNormalized: '' },
                ],
                wb_object: {
                  bsequence: sequence.id,
                  copy_workpackages: false
                }
              }).then(() => {
                sequence.likes.some(like => like.user.id === getUserId) ?
                  show_dialog = false :
                  updateWBObject({
                    url: [
                      { bsequences: sequence.id },
                      { like: '' },
                    ],
                    update: {
                      likes: getLikes(sequence.likes)
                    }
                  }).then(() => { show_dialog = false; })
              })" color="green" text>{{ $t('WorkBench.Editor.Download.WithoutWorkPackages') }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="show_dialog = false" color="red" text>Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </StandardDialog>
      <StandardFlexBox direction="column" class="font-weight-light">
        <div v-if="!create">
          <TText value="Creator{colon} {firstName} {lastName} - {email}" :value_props="{
            colon: ':',
            firstName: sequence.owner.first_name,
            lastName: sequence.owner.last_name,
            email: sequence.owner.email,
          }" font_weight="400" />
        </div>
        <div style="display: flex; grid-gap: 4px;">
          <TText value="Updated{colon} {timestamp}" :value_props="{
            colon: ':',
            timestamp: sequence.updated.substring(0, 16),
          }" font_weight="400" />
          <!-- <span v-if="!create">{{$t('WorkBench.Editor.Updated[0]')}} {{sequence.updated.substring(0, 16)}}</span> -->
          <v-btn x-small class="mr-2" @click="setMacroView(!$store.state.View.isMacroView)"
            :color="$store.state.View.isMacroView ? 'green' : ''">
            Macro
          </v-btn>
          <v-btn x-small class="mr-2" @click="setTokenView(!$store.state.View.isTokenView)"
            :color="$store.state.View.isTokenView ? 'green' : ''">
            Token
          </v-btn>
        </div>
      </StandardFlexBox>
      <StandardFlexBox class="font-weight-light ml-6" width="calc(100vw - 450px)">
        <StandardDataField v-for="(hashtag, index) in sequence.hashtags" :key="index" class="user-select-none ml-1"
          :color="$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'"
          :text_color="$vuetify.theme.isDark ? 'white' : 'black'" one_liner="true" readonly="true" :value="hashtag.tag"
          width="24%">
          <template #prepend-slot>
            <div class="user-select-none">#</div>
          </template>
          <template #append-slot>
            <StandardDeleteButton :zoom="1" @clickDelete="
              create ?
                deleteWBLObject({
                  path: [
                    { sequence: '' },
                    { hashtags: '' }
                  ],
                  index: index
                })
                :
                removeHashtag(index)
              " />
          </template>
        </StandardDataField>
        <StandardDataField v-if="!read_only" class="ml-1" :key="`addhashtag_${update_key_add_hashtag}`"
          :color="$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'"
          :text_color="$vuetify.theme.isDark ? 'white' : 'black'" one_liner="true" @changeValue="
            create ?
              createWBLObject({
                path: [
                  { sequence: '' },
                  { hashtags: '' }
                ],
                wbl_object: {
                  tag: $event.replace(/\s/g, '')
                }
              })
              :
              addHashtag($event),
            update_key_add_hashtag++
            ">
          <template #prepend-slot>
            <div class="user-select-none">#</div>
          </template>
        </StandardDataField>
      </StandardFlexBox>
    </template>
    <template #header-close>
      <template v-if="!create">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="$router.push({
              name: `WorkBenchSequences`
            })" v-on="on" v-bind="attrs">
              <v-icon color="green">done</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('WorkBench.Editor.Sequence.Toolbar.done') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-on="on" v-bind="attrs" v-if="!read_only && $route.params.template_type === 'custom'" @click="createWBObject({
              url: [
                { [`${prefix}sequences`]: sequence.id },
                { copyOwnSequence: '' }
              ],
              wb_object: {
                csequence: sequence.id
              },
              url_suffix: '?show=showWithEntitiesNormalized'
            }).then(() => {
              $router.push({
                name: `WorkBenchSequences`
              })
            })">
              <v-icon>content_copy</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('WorkBench.Editor.Sequence.Toolbar.copy') }}</span>
        </v-tooltip>
        <TUploadButton v-if="!read_only" icon="people" :value="sequence.is_community_suggested"
          :tooltip="$t('WorkBench.Editor.Sequence.Toolbar.uploadToCommunity')" @upload="updateWBObject({
            url: [
              { [`${prefix}sequences`]: sequence_id },
            ],
            update: {
              is_community_suggested: true
            }
          })" />
        <template v-if="template_type === 'community'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text :color="sequence.likes.some(like => like.user.id === getUserId) ? 'blue' : 'grey'" v-on="on"
                v-bind="attrs" @click="show_dialog = true">
                <v-icon class="mr-5">download</v-icon>
                {{ sequence.likes.length }}
              </v-btn>
            </template>
            <span>{{ $t('WorkBench.Editor.Sequence.Toolbar.download') }}</span>
          </v-tooltip>
        </template>
        <template v-if="template_type === 'company'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">

              <v-btn text :color="sequence.likes.some(like => like.user.id === getUserId) ? 'blue' : 'grey'" v-on="on"
                v-bind="attrs" @click="show_dialog = true">
                <v-icon class="mr-5">download</v-icon>
                {{ sequence.likes.length }}
              </v-btn>
            </template>
            <span>{{ $t('WorkBench.Editor.Sequence.Toolbar.download') }}</span>
          </v-tooltip>
        </template>
        <template v-if="!read_only && hasPermission('Business READ') && template_type !== 'company'">
          <TUploadButton icon="work" :counter="getWBObjectsFiltered({
            type: 'bsequences',
            filter: {
              name: sequence.name,
              owner: sequence.owner
            }
          }).length" :tooltip="$t('WorkBench.Editor.Sequence.Toolbar.uploadToCompany')" @upload="createWBObject({
  url: [
    { bsequences: 'createfromsequence' },
    { showWithEntitiesNormalized: '' }
  ],
  template_type: 'company',
  wb_object: {
    sequence_id: sequence.id
  }
})" />
        </template>
        <StandardDeleteBtn v-if="!read_only ||
          (template_type === 'company' && hasPermission('BSequence DELETE')) ||
          (template_type === 'community' && hasPermission('CSequence DELETE'))
          " :tooltip="$t('WorkBench.Editor.Sequence.Toolbar.delete')" :el="sequence" @deleteClick="deleteWBObject({
    url: [
      { [`${prefix}sequences`]: sequence.id }
    ]
  }),
    $router.push({
      name: `WorkBenchSequences`
    })" />
      </template>
      <template v-else>
        <v-btn color="orange" @click="
          resetSequence()">
          <v-icon>
            restart_alt
          </v-icon>
          Reset
        </v-btn>
        <v-spacer />
        <v-btn class="ml-2" color="green" @click="createSequence()">
          <v-progress-circular v-if="loading" indeterminate color="primary" />
          {{ $t('Buttons.Create') }}
        </v-btn>
        <v-btn depressed class="ml-2" color="grey darken-4" @click="$router.push({
          name: `WorkBenchSequences`
        })">
          {{ $t('Buttons.Cancel') }}
        </v-btn>
      </template>
    </template>
    <template #content>
      <StandardFlexBox class="mb-1" style="position: relative" width="100%" height="346px" direction="column">
        <!-- statistics -->
        <StandardFlexBox class="overflow-visible" style="position: relative" height="calc(100% - 46px)">
          <!-- settings -->
          <StandardFlexBox class="ml-1 overflow-visible" width="calc(var(--workpackage_width) + 8px)" direction="column"
            align_items="center" style="position: sticky; left: 4px">
            <StandardOverflowButton tooltip="Set Statistic" :click_to_open="true"
              :value="{ value: statistic_settings.value }" ticon="takt-plan-workpackage" :options="{
                value: [
                  { value: 'workpackages', ticon: 'takt-plan-workpackage', icon: 'dns', tooltip: 'Number_of_WORK.packages' },
                  { value: 'time_effort_planned', ticon: 'speedometer', icon: 'speed', tooltip: 'Planned_time_effort' },
                  { value: 'manpower_planned', ticon: 'person-standing', icon: 'accessibility', tooltip: 'Planned_manpower' },
                  { value: 'duration_planned', ticon: 'stopwatch', icon: 'timer', tooltip: 'Duration_planned' },
                  { value: 'sworksteps_count', icon: $store.state.Ultra.step_icons['work'], tooltip: 'Number_of_WORK.steps' },
                  { value: 'squalitysteps_count', icon: $store.state.Ultra.step_icons['quality'], tooltip: 'Number_of_QUALITY.steps' },
                  { value: 'sdefectsteps_count', icon: $store.state.Ultra.step_icons['defect'], tooltip: 'Number_of_DEFECT.steps' },
                  { value: 'shandoversteps_count', icon: $store.state.Ultra.step_icons['handover'], tooltip: 'Number_of_HANDOVER.steps' },
                  { value: 'slogisticsteps_count', icon: $store.state.Ultra.step_icons['logistic'], tooltip: 'Number_of_LOGISTIC.steps' },
                  { value: 'sdesignsteps_count', icon: $store.state.Ultra.step_icons['design'], tooltip: 'Number_of_DESIGN.steps' },
                  { value: 'sworkpackageimages_count', ticon: 'image', icon: 'photo', tooltip: 'Number_of_images' },
                  { value: 'costs_budget_labour', ticon: 'wallet', icon: 'account_balance_wallet', tooltip: 'Labour_budget' },
                  { value: 'costs_budget_material', ticon: 'wallet', icon: 'account_balance_wallet', tooltip: 'Material_budget' },
                ]
              }" @select-option="updateWBLObject({
  path: [
    { sequence_editor_variables: 'statistic_settings' }
  ],
  update: {
    value: $event.value
  }
})" />
            <v-divider class="mt-1 mb-1" width="90%" color="grey" />
            <StandardOverflowButton tooltip="Statistic Settings" :click_to_open="true"
              :value="{ cumulative: statistic_settings.cumulative }" ticon="poll" :options="[
                'manpower_planned',
                'manpower_actual',
                'time_effort_planned',
                'time_effort_actual',
                'calendar',
              ].includes(statistic_settings.value) ?
                {
                  cumulative: [
                    { value: false, ticon: 'poll', icon: 'bar_chart', tooltip: 'Cumulative' },
                  ]
                }
                :
                {
                  cumulative: [
                    { value: false, ticon: 'poll', icon: 'bar_chart', tooltip: 'Per TAKT.time' },
                    { value: true, ticon: 'ascending', icon: 'signal_cellular_alt', tooltip: 'Cumulative' }
                  ]
                }
                " @select-option="updateWBLObject({
    path: [
      { sequence_editor_variables: 'statistic_settings' }
    ],
    update: {
      cumulative: $event.value
    }
  })" />
            <!-- <v-divider class="mt-1 mb-1" width="90%" color="grey"/>
            <StandardOverflowButton
              :click_to_open="true"
              icon="filter_list"
              :multiselect="true"
              :button_color="statistic_settings.filter? 'color-3':''"
              :value="{
                icons: statistic_settings.icons,
                colors: statistic_settings.colors,
                }"
              :options="{
                icons: getSequenceWorkpackageIcons({
                  swaggons: sequence.swaggons,
                  local: create,
                  prefix: '',
                  }),
                colors: getSequenceWorkpackageColors({
                  swaggons: sequence.swaggons,
                  local: create,
                  prefix: '',
                  }),
                }
                "
              @select-option="updateWBLObject({
                path: [
                  {sequence_editor_variables: 'statistic_settings'}
                ],
                update: {
                  [$event.setting]: $event.value
                }
              })"
              /> -->
            <!-- <v-btn
                icon
                :class="!statistic_settings.filter? 'color-3':''"
                @click="updateWBLObject({
                  path: [
                    {sequence_editor_variables: 'statistic_settings'}
                  ],
                  update: {
                    filter: !statistic_settings.filter
                  }
                })"
                >
                <v-icon>visibility_off</v-icon>
              </v-btn> -->
          </StandardFlexBox>
          <!-- values -->
          <StatisticsTakt v-for="(waggon_values, waggon_values_index) in statistics.waggon_values"
            :key="`statistics_waggon_${waggon_values_index}`" no_zoom="true">
            <StatisticsBeamTaktSum v-if="waggon_values.waggon_sum !== 0" height="24px">
              {{ waggon_values.waggon_sum }}
            </StatisticsBeamTaktSum>
            <StatisticsBeam v-for="(waggon_value, waggon_value_index) in waggon_values.values"
              :key="`statistics_waggon_value_${waggon_value_index}`" :value="waggon_value.value"
              :max_value="statistics.max_waggon_sum" :color="waggon_value.color" :no_zoom="true" />
          </StatisticsTakt>
        </StandardFlexBox>
        <!-- sequence -->
        <StandardFlexBox class="mr-1 ml-1 mt-1 overflow-visible" height="42px" style="position: relative" no_wrap="true">
          <TrainHead :style="`${!$route.matched[3] && swaggon_rec_pos === 0 ||
              swaggon_rec_pos !== 0 && swaggon_rec_pos === 1
              ?
              '' : 'opacity: 0.5;'
            }
                  transition: opacity 0.2s ease-in-out;
                   `
            " :zoom="1" />
          <div v-if="!read_only && sequence[`${prefix}swaggons`].length === 0" style="margin: 21px 6px;">
            <Activator key="nowaggonsactivtor" class="self-centered cursor-cell" @click.native="$router.push({
              name: 'WorkBenchSequenceWaggonAdd',
              params: {
                sequence_index: 0,
                add_before: false
              }
            })" />
          </div>
          <draggable v-else class="display-flex" key="waggons" animation="300" forceFallback="true" fallbackOnBody="true"
            :disabled="read_only || $route.name !== 'WorkBenchSequenceEditor'" :value="sequence[`${prefix}swaggons`]"
            @input="
              create ?
                updateWBLObject({
                  path: [
                    { sequence: '' },
                    { swaggons: '' }
                  ],
                  update: $event,
                })
                :
                ''
              " @end="
    create ?
      routeToWaggonWorkPackage({}, 2)
      /* $router.push({
        name: `WorkBenchSequenceWaggon`,
        params: {waggon_id: $event.newIndex}
        }) */
      :
      changeWBObjectPosition({
        url: [
          { [`${prefix}sequences`]: sequence_id },
          { [`${prefix}swaggons`]: sequence[`${prefix}swaggons`][$event.oldIndex] },
          { pushpositions: '' }
        ],
        target: {
          target_id: sequence[`${prefix}swaggons`][$event.newIndex],
        }
      })">
            <v-hover
              v-for="(waggon, waggon_index) in create ? sequence.swaggons : getWBObjects({ type: `${prefix}swaggons`, ids: sequence[`${prefix}swaggons`] })"
              :key="`waggonhoveractivtor${create ? waggon_index : waggon.id}`" @click.native="!read_only || waggon[`${prefix}sworkpackages`].length !== 0 ?
                routeToWaggonWorkPackage(waggon, waggon[`${prefix}sworkpackages`][0], waggon_index) : ''">
              <template #default="hover_waggon_slot">
                <transition name="grow-x">
                  <Waggon :workpackage_count="waggon[`${prefix}sworkpackages`].length" :style="`${($route.matched[3] && $route.matched[3].name === 'WorkBenchSequenceWaggon' &&
                      $route.params.waggon_id === (create ? waggon_index : waggon.id))
                      || hover_waggon_slot.hover || !$route.matched[3] && swaggon_rec_pos === 0 ||
                      swaggon_rec_pos !== 0 && (swaggon_rec_pos === waggon_index + 1 || swaggon_rec_pos === waggon_index + 2) ||
                      swaggon_rec_pos !== 0 && swaggon_rec_pos > sequence[`${prefix}swaggons`].length && waggon_index === sequence[`${prefix}swaggons`].length - 1
                      ?
                      '' : 'opacity: 0.5;'
                    }
                                            ${($route.matched[3] && $route.matched[3].name === 'WorkBenchSequenceWaggon' &&
                      $route.params.waggon_id === (create ? waggon_index : waggon.id))
                      ?
                      'background-color: white; border-radius: 4px;' : ''
                    }
                          transition: opacity 0.2s ease-in-out;
                           `
                    " :zoom="1">
                    <template #prepend v-if="!read_only && $route.name === 'WorkBenchSequenceEditor' &&
                      (hover_waggon_slot.hover || (swaggon_rec_pos === waggon_index + 1))
                      ">
                      <Activator class="self-centered cursor-cell"
                        @click.native.prevent.stop="createWaggonTemp(waggon_index, true)" />
                    </template>
                    <template #append v-if="!read_only && $route.name === 'WorkBenchSequenceEditor' && (hover_waggon_slot.hover ||
                      swaggon_rec_pos === waggon_index + 2 ||
                      swaggon_rec_pos > sequence[`${prefix}swaggons`].length && waggon_index === sequence[`${prefix}swaggons`].length - 1)
                      ">
                      <Activator class="self-centered cursor-cell"
                        @click.native.prevent.stop="createWaggonTemp(waggon_index + 1, false)" />
                    </template>
                    <template #badge>
                      <StandardDeleteButton
                        v-if="!read_only && $route.name === 'WorkBenchSequenceEditor' && hover_waggon_slot.hover"
                        :zoom="1" direction="left" @clickDelete="
                          create ?
                            deleteWBLObject({
                              path: [
                                { sequence: '' },
                                { swaggons: '' }
                              ],
                              index: waggon_index
                            })
                            :
                            deleteWBObject({
                              url: [
                                { [`${prefix}sequences`]: sequence_id },
                                { [`${prefix}swaggons`]: waggon.id }
                              ]
                            }),
                          $router.push({
                            name: `WorkBenchSequenceEditor`,
                            sequence_id: sequence_id
                          })
                          " />
                    </template>
                    <template #content>
                      <StandardHover v-if="$route.name === 'WorkBenchSequenceEditor' && hover_waggon_slot.hover"
                        :class="read_only ? 'cursor-pointer' : 'cursor-grab'" />
                      <div v-if="$store.state.View.isMacroView" class="makro-view">
                        {{ waggon_index + 1 }}
                      </div>
                      <div v-if="$store.state.View.isTokenView" class="token-view">
                        <!-- {{ waggon.token ? waggon.token : '' }} -->
                        <input class="waggon-token-input" type="text" maxlength="5"
                          :value="waggon.token ? waggon.token : ''"
                          @change="updateToken(create ? waggon_index : waggon.id, $event.target.value)" />
                      </div>
                      <draggable class="display-flex flex-wrap"
                        :key="`workpackageswaggon${create ? waggon_index : waggon.id}`"
                        :id="`workpackageswaggon${create ? waggon_index : waggon.id}`" group="workpackages"
                        :component-data="getDraggableStyle()" animation="300" forceFallback="true" fallbackOnBody="true"
                        :disabled="read_only || $route.name === 'WorkBenchSequenceEditor'"
                        :value="create ? waggon.sworkpackages : waggon[`${prefix}sworkpackages`]" @input="
                          create ?
                            updateWBLObject({
                              path: [
                                { sequence: '' },
                                { swaggons: waggon_index },
                                { sworkpackages: '' }
                              ],
                              update: $event,
                            })
                            :
                            ''
                          " @update="
    create ?
      (
        ($route.params.waggon_id !== parseInt($event.to.id.substring(18, $event.to.id.length)) ||
          $route.params.work_package_id !== $event.newIndex) ?
          routeToWaggonWorkPackage(waggon, $event.newIndex)
          : ''
      )
      :
      changeWBObjectPosition({
        url: [
          { [`${prefix}sequences`]: sequence_id },
          { [`${prefix}swaggons`]: waggon.id },
          { [`${prefix}sworkpackages`]: waggon[`${prefix}sworkpackages`][$event.oldIndex] },
          { pushpositions: '' }
        ],
        target: {
          target_id: waggon[`${prefix}sworkpackages`][$event.newIndex],
        }
      })" @start="
      draggable_old_twaggon_id = create ? waggon_index : waggon.id,
      draggable_wp_id = waggon[`${prefix}sworkpackages`][$event.oldIndex],
      create ?
        routeToWaggonWorkPackage(waggon, $event.oldIndex)

        : ''
      " @remove="
    create ?
      deleteWBLObject({
        path: [
          { sequence: '' },
          { swaggons: parseInt($event.from.id.substring(18, $event.from.id.length)) },
          { sworkpackages: '' }
        ],
        index: $event.oldIndex
      }).then(() => {
        ($route.params.waggon_id !== parseInt($event.to.id.substring(18, $event.to.id.length)) ||
          $route.params.work_package_id !== $event.newIndex) ?
          routeToWaggonWorkPackage(waggon, $event.newIndex)
          :
          ''
      })
      :
      changeWBObjectParent({
        url: [
          { [`${prefix}sequences`]: sequence_id },
          { [`${prefix}swaggons`]: waggon.id },
          { [`${prefix}sworkpackages`]: waggon[`${prefix}sworkpackages`][$event.oldIndex] },
          { updateparent: '' }
        ],
        update: {
          parent_id: parseInt($event.to.id.substring(18, $event.to.id.length)),
          position: $event.newIndex + parseInt(1),
        }
      }).then(() => {
        routeToWaggonWorkPackage(waggon, draggable_wp_id)
        /* $router.push({
          name: `WorkBenchSequenceWaggonWorkPackage`,
          params: {
            waggon_id: parseInt($event.to.id.substring(18, $event.to.id.length)),
            work_package_id: draggable_wp_id,
          }
          }) */
      })
    ">
                        <v-hover
                          v-for="(workpackage, workpackage_index) in create ? waggon.sworkpackages : getWBObjects({ type: `${prefix}sworkpackages`, ids: waggon[`${prefix}sworkpackages`] })"
                          :key="`workpackage${create ? workpackage_index : workpackage.id}`">
                          <template #default="{ hover }">
                            <Workpackage :workpackage_count="waggon[`${prefix}sworkpackages`].length"
                              :workpackage="workpackage" :zoom="1">
                              <template #workpackage>
                                <StandardHover v-if="hover && !read_only && $route.name !== 'WorkBenchSequenceEditor'"
                                  class="cursor-grab" :key="`workpackagehover${create ? workpackage_index : workpackage.id}`"
                                  style="z-index: 10" />
                              </template>
                            </Workpackage>
                          </template>
                        </v-hover>
                      </draggable>
                    </template>
                  </Waggon>
                </transition>
              </template>
            </v-hover>
          </draggable>
          <!-- ||
          (swaggon_rec_index.length !== 0 && swaggon_rec_index.includes(sequence.swaggons.length-1)) -->
          <TrainTail :style="`${!$route.matched[3] && swaggon_rec_pos === 0 ||
              swaggon_rec_pos !== 0 && swaggon_rec_pos > sequence[`${prefix}swaggons`].length
              ?
              '' : 'opacity: 0.5;'
            }
                  transition: opacity 0.2s ease-in-out;
                   `
            " :zoom="1" />
        </StandardFlexBox>
      </StandardFlexBox>
      <!-- bottom box -->
      <StandardFlexBox
        :class="`ml-1 mr-1 pa-1 t-rounded t-shadow font-weight-light ${$vuetify.theme.isDark ? 'grey darken-4' : 'grey lighten-3'}`"
        height="calc(100% - 350px)">
        <template v-if="!read_only">
          <StandardFlexBox width="33%" height="100%" class="mr-3" direction="column">
            <AIIcon v-if="ai_animation_recommendation" :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`"
              style="margin-left: calc(50% - 100px); margin-top: 30px" width="200px" :animation="true" />
            <template v-else>
              <StandardFlexBox height="24px">
                <AIIcon :color="`${$vuetify.theme.isDark ? 'white' : 'black'}`" class="mr-1" style="margin-top: 2px"
                  width="18px" @click.native="test()" />
                <div class="font-weight-light">
                  {{ $t('WorkBench.Editor.Sequence.Recommendations') }}:
                </div>
              </StandardFlexBox>
              <StandardFlexBox height="calc(100% - 24px)"
                v-if="getWBObject({ type: 'swaggonrecommendations', id: $route.params.sequence_id })">
                <!-- <Waggon
                v-for="(waggon, index) in getWBObject({type: 'swaggonrecommendations',id: $route.params.sequence_id}).waggons"
                :key="index"
                :workpackage_count="waggon.sworkpackages.length"
                >
                <template #content>
                <Workpackage
                  v-for="(workpackage, index) in waggon.sworkpackages"
                  :key="index"
                  :workpackage_count="waggon.sworkpackages.length"
                  :workpackage="workpackage"
                  />
                </template>
              </Waggon> -->
                <!-- .sort(function (a, b) {return a.position - b.position;}) -->
                <SWaggonRecommendation class="ma-2 cursor-pointer"
                  v-for="(waggon, index) in getWBObject({ type: 'swaggonrecommendations', id: $route.params.sequence_id }).waggons"
                  :key="index" :recommended_waggon="waggon" :prev_workpackages="waggon.position <= 1 ? false :
                    (create ?
                      sequence.swaggons[waggon.position - 2 <= sequence.swaggons.length - 1 ? waggon.position - 2 : sequence.swaggons.length - 1].sworkpackages
                      :
                      getWBObjects({ type: 'sworkpackages', ids: getWBObject({ type: 'swaggons', id: sequence.swaggons[waggon.position - 2 <= sequence.swaggons.length - 1 ? waggon.position - 2 : sequence.swaggons.length - 1] }).sworkpackages })
                    )" :next_workpackages="waggon.position >= sequence.swaggons.length + 1 ? false :
    (create ?
      sequence.swaggons[waggon.position - 1].sworkpackages
      :
      getWBObjects({ type: 'sworkpackages', ids: getWBObject({ type: 'swaggons', id: sequence.swaggons[waggon.position - 1] }).sworkpackages })
    )" @mouseenter.native="swaggon_rec_pos = waggon.position" @mouseleave.native="swaggon_rec_pos = 0"
                  @click.native="$router.push({
                    name: 'RecommendedWaggonWorkPackageInfo',
                    params: {
                      rec_waggon_index: index,
                      rec_waggon_work_package_index: 0
                    }
                  })" />
              </StandardFlexBox>
            </template>
          </StandardFlexBox>
          <StandardFlexBox v-if="$route.matched[3] && $route.matched[3].name === 'RecommendedWaggon'" height="100%"
            direction="column" justify_content="space-between">
            <router-view style="z-index: 20" />
            <v-btn @click="
              create ?
                createWBLObject({
                  path: [
                    { sequence: '' },
                    { swaggons: '' }
                  ],
                  wbl_object: getWBObject({
                    type: 'swaggonrecommendations',
                    id: $route.params.sequence_id
                  }).waggons[$route.params.rec_waggon_index]
                })
                :
                createWBObject({
                  url: [
                    { [`${prefix}sequences`]: sequence_id },
                    { [`${prefix}swaggons`]: 'completeswaggon' },
                    { showWithEntitiesNormalized: '' }
                  ],
                  wb_object: getWBObject({
                    type: 'swaggonrecommendations',
                    id: $route.params.sequence_id
                  }).waggons[$route.params.rec_waggon_index]
                })
              ">
              add waggon
            </v-btn>
          </StandardFlexBox>
          <StandardFlexBox v-if="$route.matched[3] && $route.matched[3].name === 'RecommendedWaggon'"
            class="cursor-pointer" height="100%" width="40px" direction="column" justify_content="center"
            align_content="center" @click.native="$router.push({
              name: `WorkBenchSequenceEditor`
            })">
            <v-icon>keyboard_arrow_left</v-icon>
          </StandardFlexBox>
        </template>
        <StandardFlexBox class="pa-1" width="30%" height="100%" :style="!read_only ? 'border-left: solid 1px white' : ''">
          <StandardDataField placeholder="name" width="100%" height="26px"
            :color="$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'"
            :text_color="$vuetify.theme.isDark ? 'white' : 'black'" :value="sequence.name" :readonly="read_only"
            @changeValue="
              create ?
                updateWBLObject({
                  path: [
                    { sequence: '' },
                  ],
                  update: {
                    name: $event
                  }
                })
                :
                updateWBObject({
                  url: [
                    { [`${prefix}sequences`]: sequence_id },
                  ],
                  update: {
                    name: $event
                  }
                })" />
        </StandardFlexBox>
      </StandardFlexBox>
    </template>
  </StandardDialogFullScreen>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { WorkBenchSequenceMixin } from '@/mixins/WorkBenchSequence.mixin.js'
export default {
  props: [
    'sequence_id',
    'template_type',
    'create',
    'read_only',
    'location',
  ],
  mixins: [
    WorkBenchSequenceMixin,
  ],
  data: () => ({
    loading: false,
    show_dialog: false,
    draggable_old_twaggon_id: -1,
    draggable_wp_id: -1,
    editor_update_key: 0,
  }),
  computed: {
    ...mapGetters('Auth', [
      'getUser',
      'hasPermission'
    ])
  },
  created() {
   
  },
  watch: {
    
  },
  methods: {
    createSequence() {
      // console.log(this.$route.params)
      // this.loading = true;

      let url = [
          { sequences: 'completesequence' },
          { showWithEntitiesNormalized: '' }
        ];

      if (this.$route.params.sfolder !== 'last-updated') {
        // append { sfolders: this.$route.params.sfolder } to the start of the url
        url.unshift({ sfolders: this.$route.params.sfolder });
      }

      this.createWBObject({
        url: url,
        wb_object: this.getSequenceForCreateCall()
      }).then((id) => {
        this.uploadSequenceWorkpackagesImageBulk(id)
      })
    },
    getDraggableStyle() {
      return { attrs: { 'style': `width: calc((var(--workpackage_width) + 4px)); height: calc((var(--workpackage_height) + 4px))` } };
    },
    routeToWaggonWorkPackage(waggon, workpackage_id, waggon_index) {
      if (waggon[`${this.prefix}sworkpackages`].length > 0) {
        this.$router.push({
          name: `${this.location}SequenceWaggonWorkPackage`,
          params: {
            waggon_id: this.create ? waggon_index : waggon.id,
            workpackage_id: this.create ? 0 : workpackage_id
          }
        });
      } else {
        this.$router.push({
          name: `${this.location}SequenceWaggonWorkPackageAdd`,
          params: {
            waggon_id: this.create ? waggon_index : waggon.id
          }
        });
      }
    },
    createWaggonTemp(waggon_index, add_before) {
      if (this.prefix === '') {
        this.$router.push({
          name: 'WorkBenchSequenceWaggonAdd',
          params: {
            sequence_index: waggon_index,
            add_before: add_before
          }
        })
      } else {
        if (this.create) {
          this.createWBLObject({
            path: [
              { sequence: '' },
              { swaggons: '' }
            ],
            wbl_object: {
              sworkpackages: [],
              position: waggon_index + parseInt(1)
            }
          });
        } else {
          this.createWBObject({
            url: [
              { [`${this.prefix}sequences`]: this.sequence_id },
              { [`${this.prefix}swaggons`]: '' },
              { showWithEntitiesNormalized: '' }
            ],
            wb_object: {
              position: waggon_index + parseInt(1)
            },
          });
        }
      }
    },
    updateToken(waggon_id, token) {
      if (this.create) {
        this.updateWBLObject({
          path: [
            { sequence: '' },
            { swaggons: waggon_id },
          ],
          update: {
            token: token
          }
        })
      } else {
        this.updateWBObject({
          url: [
            { [`${this.prefix}sequences`]: this.sequence_id },
            { [`${this.prefix}swaggons`]: waggon_id },
          ],
          update: {
            token: token
          }
        })
      }
    },
    ...mapActions('View', [
      'setMacroView',
      'setTokenView'
    ]),
  }
}
</script>
<style>
.grow-x-enter,
.grow-x-leave-to {
  width: 0px;
}

.grow-x-enter-active,
.grow-x-leave-active {
  overflow: hidden;
  transition: all 0.1s ease-in-out;
}

.makro-view {
  height: 100%;
  width: 100%;
  background-color: rgb(138 138 138 / 50%);
  position: absolute;
  z-index: 2;
  text-align: center;
  padding-top: 7px;
}

.token-view {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgb(106 106 106 / 80%);
  z-index: 2;
  cursor: pointer;
  font-weight: bold;
}

.waggon-token-input {
  width: 100%;
  height: 100%;
  padding: 2px;
  text-align: center;
}
</style>
